
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Index from "./pages/Index";
import SDGsPage from "./pages/SDGsPage";
import SDGPage from "./pages/SDGPage";
import StoryPage from "./pages/StoryPage";
import MediaPage from "./pages/MediaPage";
import JourneyPage from "./pages/JourneyPage";
import ControlPanelPage from "./pages/ControlPanelPage";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/sdgs" element={<SDGsPage />} />
            <Route path="/sdgs/:slug" element={<SDGPage />} />
            <Route path="/stories/:slug" element={<StoryPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/journey" element={<JourneyPage />} />
            <Route path="/admin" element={<ControlPanelPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
